define('lib/audio/construct-api-audio',['require','lodash'],function (require) {
    var _ = require('lodash');

    return function (localAudio, allowedModes) {
        var apiAudio = {};

        apiAudio.defaultModes = [];
        if (!localAudio.isPrivate) {
            if (_.includes(allowedModes, 'VOIP') && localAudio.isVoip) {
                apiAudio.defaultModes.push('VOIP');
            }

            if (_.includes(allowedModes, 'DIALOUT')) {
                if (localAudio.isDialOut) {
                    apiAudio.defaultModes.push('DIALOUT');
                }
                apiAudio.isDialOutDefault = localAudio.isDialOut;
                apiAudio.defaultDialOutCountries = _.pluck(localAudio.dialOutCountries, 'country');
            }

            if (_.includes(allowedModes, 'TOLL')) {
                if (localAudio.isToll) {
                    apiAudio.defaultModes.push('TOLL');
                }

                apiAudio.defaultTollCountries = _.pluck(localAudio.tollCountries, 'country');

                if (localAudio.preferredTollCountry) {
                    apiAudio.preferredTollCountry = localAudio.preferredTollCountry.country;
                } else {
                    apiAudio.preferredTollCountry = '';
                }
            }

            if (_.includes(allowedModes, 'TOLLFREE')) {
                if (localAudio.isTollFree) {
                    apiAudio.defaultModes.push('TOLLFREE');
                }

                apiAudio.defaultTollFreeCountries = _.pluck(localAudio.tollFreeCountries, 'country');

                if (localAudio.preferredTollFreeCountry) {
                    apiAudio.preferredTollFreeCountry = localAudio.preferredTollFreeCountry.country;
                } else {
                    apiAudio.preferredTollFreeCountry = '';
                }
            }
        } else if (_.includes(allowedModes, 'PRIVATE')) {
            apiAudio.defaultModes.push('PRIVATE');
            apiAudio.defaultModeratorPrivateMessage = localAudio.privateMessage;
        }

        return apiAudio;
    };
});

